<ion-content class="billing-modal-content" [fullscreen]="true">
  <div class="billing-modal-body">
    <h3 class="billing-modal-title">{{ 'billing.modal.title' | translate }}</h3>

    <ng-container *ngIf="billingDetails as b; else missingDetails">
      <div class="billing-modal-lines">
        <p *ngIf="b.legalName" class="billing-line">{{ b.legalName }}</p>
        <p *ngIf="b.address" class="billing-line">{{ b.address }}</p>
        <p *ngIf="b.zipCode || b.city" class="billing-line">
          <span *ngIf="b.zipCode">{{ b.zipCode }}</span>
          <span *ngIf="b.zipCode && b.city">&nbsp;</span>
          <span *ngIf="b.city">{{ b.city }}</span>
        </p>
        <p *ngIf="b.vatNumber" class="billing-line">
          {{ 'billing.vatNumber' | translate: { vat: b.vatNumber } }}
        </p>
        <p *ngIf="b.recipientCode" class="billing-line">
          {{ 'billing.recipientCode' | translate: { code: b.recipientCode } }}
        </p>
        <p *ngIf="b.projectCode" class="billing-line">
          {{ 'billing.projectCode' | translate: { code: b.projectCode } }}
        </p>
        <p *ngIf="b.projectName" class="billing-line">
          {{ 'billing.projectName' | translate: { name: b.projectName } }}
        </p>
      </div>

      <p
        class="billing-line"
        *ngIf="!b.legalName && !b.address && !b.zipCode && !b.city && !b.vatNumber && !b.recipientCode && !b.projectCode && !b.projectName"
      >
        {{ 'billing.notAvailable' | translate }}
      </p>
    </ng-container>

    <ng-template #missingDetails>
      <p class="billing-line">{{ 'billing.notAvailable' | translate }}</p>
    </ng-template>
  </div>
</ion-content>

<ion-footer class="billing-modal-footer" mode="ios">
  <ion-toolbar>
    <ion-button expand="block" fill="clear" color="primary" class="billing-modal-copy" (click)="copyBillingDetails()">
      <ion-icon slot="start" name="copy-outline"></ion-icon>
      {{ 'billing.modal.copy' | translate }}
    </ion-button>
    <ion-button expand="block" fill="clear" color="primary" class="billing-modal-ok" (click)="close()">
      {{ 'billing.modal.ok' | translate }}
    </ion-button>
  </ion-toolbar>
</ion-footer>
